import { Provider } from '@angular/core';

import { AuthenticationStore } from '@customer-portal/ciam';
// KP: this app-level provider factory necessarily imports statically (providers must exist before
// the lazy route ever loads), which trips the "static import of lazy-loaded library" rule now that
// customer-chat is one merged domain project. This is the same composition-root shape Phase 4
// anticipated for the old `domains/core` -- it didn't actually need this relaxation itself (see
// Docs/Decisions/adr_domain_libs_sheriff_boundaries.md), because src/app/ is where the real
// static+lazy mixing happens, not inside a domain. `core` itself later moved into src/app/core
// (it's not a cross-domain-importable library, so it never needed a Sheriff/Nx tag at all).
// eslint-disable-next-line @nx/enforce-module-boundaries
import { CustomerChatConfig, CustomerChatTokenProvider } from '@customer-portal/domains/customer-chat/data-access';

import { environment } from '../environments/environment';

/**
 * Wires the Customer Chat data-access lib at the app level:
 *  - `CustomerChatConfig.baseUrl` from `environment` (libs never import `environment`);
 *  - bridges `CustomerChatTokenProvider` to `AuthenticationStore` so the client can attach the bearer
 *    token explicitly (the BFF is a different origin, so the API interceptor won't).
 */
export function provideCustomerChat(): Provider[] {
  return [
    {
      provide: CustomerChatConfig,
      useFactory: () => {
        const config = new CustomerChatConfig();
        config.baseUrl = environment.customerChat.baseUrl;
        return config;
      },
    },
    { provide: CustomerChatTokenProvider, useExisting: AuthenticationStore },
  ];
}
